export const SET_REJECTED_FILTERS = 'SET_REJECTED_FILTERS';

export const SET_CURRENT_SELECTED_REJECTED = 'SET_CURRENT_SELECTED_REJECTED';

export const SET_CURRENT_REJECTED_DETAILS = 'SET_CURRENT_REJECTED_DETAILS';

export const SET_REJECTED_GRID_SORT_CRITERIA = 'SET_REJECTED_GRID_SORT_CRITERIA';

export const SET_REJECTED_PAGINATION = 'SET_REJECTED_PAGINATION';

export const RESET_REJECTED_FILTERS = 'RESET_REJECTED_FILTERS';
